import { Types } from "actions/call-quality";
import { createReducer } from "utils/reducer";

const initialState = {
  // Dashboard data
  dashboard: null,
  isFetchingDashboard: false,
  // Individual calls
  calls: [],
  callsTotalCount: 0,
  callsPage: 1,
  callsPageSize: 50,
  callsTotalPages: 0,
  isFetchingCalls: false,
  // By Coach aggregation
  byCoach: [],
  isFetchingByCoach: false,
  // By Company aggregation
  byCompany: [],
  isFetchingByCompany: false,
  // By Team aggregation
  byTeam: [],
  isFetchingByTeam: false,
  // Filter options
  filterOptions: null,
  isFetchingFilterOptions: false
};

export default createReducer(initialState, {
  // Dashboard
  [Types.CALL_QUALITY_DASHBOARD_REQUEST]: state => ({
    ...state,
    isFetchingDashboard: true
  }),
  [Types.CALL_QUALITY_DASHBOARD_SUCCESS]: (state, action) => ({
    ...state,
    dashboard: action.payload,
    isFetchingDashboard: false
  }),
  [Types.CALL_QUALITY_DASHBOARD_FAILURE]: state => ({
    ...state,
    isFetchingDashboard: false
  }),

  // Individual Calls
  [Types.CALL_QUALITY_CALLS_REQUEST]: state => ({
    ...state,
    isFetchingCalls: true
  }),
  [Types.CALL_QUALITY_CALLS_SUCCESS]: (state, action) => {
    const payload = action.payload || {};
    const calls = payload.calls || [];
    const totalCount = payload.totalCount ?? calls.length;
    const pageSize = payload.pageSize || 50;
    return {
      ...state,
      calls,
      callsTotalCount: totalCount,
      callsPage: payload.page || 1,
      callsPageSize: pageSize,
      callsTotalPages: payload.totalPages ?? Math.ceil(totalCount / pageSize),
      isFetchingCalls: false
    };
  },
  [Types.CALL_QUALITY_CALLS_FAILURE]: state => ({
    ...state,
    isFetchingCalls: false
  }),

  // By Coach
  [Types.CALL_QUALITY_BY_COACH_REQUEST]: state => ({
    ...state,
    isFetchingByCoach: true
  }),
  [Types.CALL_QUALITY_BY_COACH_SUCCESS]: (state, action) => ({
    ...state,
    byCoach: action.payload.items || [],
    isFetchingByCoach: false
  }),
  [Types.CALL_QUALITY_BY_COACH_FAILURE]: state => ({
    ...state,
    isFetchingByCoach: false
  }),

  // By Company
  [Types.CALL_QUALITY_BY_COMPANY_REQUEST]: state => ({
    ...state,
    isFetchingByCompany: true
  }),
  [Types.CALL_QUALITY_BY_COMPANY_SUCCESS]: (state, action) => ({
    ...state,
    byCompany: action.payload.items || [],
    isFetchingByCompany: false
  }),
  [Types.CALL_QUALITY_BY_COMPANY_FAILURE]: state => ({
    ...state,
    isFetchingByCompany: false
  }),

  // By Team
  [Types.CALL_QUALITY_BY_TEAM_REQUEST]: state => ({
    ...state,
    isFetchingByTeam: true
  }),
  [Types.CALL_QUALITY_BY_TEAM_SUCCESS]: (state, action) => ({
    ...state,
    byTeam: action.payload.items || [],
    isFetchingByTeam: false
  }),
  [Types.CALL_QUALITY_BY_TEAM_FAILURE]: state => ({
    ...state,
    isFetchingByTeam: false
  }),

  // Filter Options
  [Types.CALL_QUALITY_FILTER_OPTIONS_REQUEST]: state => ({
    ...state,
    isFetchingFilterOptions: true
  }),
  [Types.CALL_QUALITY_FILTER_OPTIONS_SUCCESS]: (state, action) => ({
    ...state,
    filterOptions: action.payload,
    isFetchingFilterOptions: false
  }),
  [Types.CALL_QUALITY_FILTER_OPTIONS_FAILURE]: state => ({
    ...state,
    isFetchingFilterOptions: false
  })
});

export const selectors = {
  // Dashboard
  getCallQualityDashboard: state => state.get("call-quality")?.dashboard,
  getIsFetchingCallQualityDashboard: state => state.get("call-quality")?.isFetchingDashboard,
  // Individual Calls
  getCallQualityCalls: state => state.get("call-quality")?.calls || [],
  getCallQualityCallsTotalCount: state => state.get("call-quality")?.callsTotalCount || 0,
  getCallQualityCallsPage: state => state.get("call-quality")?.callsPage || 1,
  getCallQualityCallsPageSize: state => state.get("call-quality")?.callsPageSize || 50,
  getCallQualityCallsTotalPages: state => state.get("call-quality")?.callsTotalPages || 0,
  getIsFetchingCallQualityCalls: state => state.get("call-quality")?.isFetchingCalls,
  // By Coach
  getCallQualityByCoach: state => state.get("call-quality")?.byCoach || [],
  getIsFetchingCallQualityByCoach: state => state.get("call-quality")?.isFetchingByCoach,
  // By Company
  getCallQualityByCompany: state => state.get("call-quality")?.byCompany || [],
  getIsFetchingCallQualityByCompany: state => state.get("call-quality")?.isFetchingByCompany,
  // By Team
  getCallQualityByTeam: state => state.get("call-quality")?.byTeam || [],
  getIsFetchingCallQualityByTeam: state => state.get("call-quality")?.isFetchingByTeam,
  // Filter Options
  getCallQualityFilterOptions: state => state.get("call-quality")?.filterOptions,
  getIsFetchingCallQualityFilterOptions: state => state.get("call-quality")?.isFetchingFilterOptions
};
